@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.body {
  @include hide-scrollbar;
  padding: 0 var(--designer-right-rail-panel-padding) var(--designer-right-rail-panel-padding)
    var(--designer-right-rail-panel-padding);
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.sectionTitle {
  padding: 0 0px;
}

.sectionCard {
  @include blur(35px);
  display: flex;
  align-items: center;
  gap: 5px;
  align-self: stretch;
  border-radius: 10px;
  background: var(--light-100);
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
}

.sectionActions {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

// New styles for isScheduledPostsV3 interface
.toolbar {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.toolbarItem {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.previewButtons {
  display: flex;
  gap: 10px;
  width: 100%;
}
